import React, { useEffect, useState } from 'react';
import api from '../../config/axios';
import { InputMask } from '@react-input/mask';

import GestoraModal from './modals/Gestora';
import Paginacao from '../../components/utils/paginacao';

import '../../assets/styles/clientes.css';
import { FaPlus, FaEdit, FaFilter, FaStore } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Gestoras = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [gestoras, setGestoras] = useState([]);
  const [filtroNome, setFiltroNome] = useState('');
  const [filtroEmail, setFiltroEmail] = useState('');
  const [filtroCnpj, setFiltroCnpj] = useState('');

  const [selectedGestora, setSelectedGestora] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const fetchGestoras = async (currentPage) => {
    try {
      Swal.fire({
        title: "Carregando...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const params = {
        page: currentPage,
        limit: limit,
        nome: filtroNome,
        email: filtroEmail,
        cnpj: filtroCnpj
      };

      const response = await api.get('/gestoras', { params });

      setGestoras(response.data.gestoras || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar os dados. Tente novamente mais tarde.');
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchGestoras(currentPage);
  }, [currentPage]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleAddGestora = () => {
    setSelectedGestora(null);
    setIsModalOpen(true);
  };

  const handleEditGestora = (gestora) => {
    setSelectedGestora(gestora);
    setIsModalOpen(true);
  };

  const handleUnidadesGestora = (gestora) => {
    navigate(`/gestoras/${gestora.id}/unidades`);
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchGestoras(1);
  };

  const handleLimparFiltros = () => {
    setFiltroNome('');
    setFiltroEmail('');
    setFiltroCnpj('');
  };

  const formatCnpj = (cnpj) => {
    if (!cnpj) return '';
    const cnpjStr = cnpj.toString();
    return cnpjStr.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold">Gestoras</h4>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-6 col-12">
              <button className="btn btn-outline-primary" onClick={handleAddGestora}>
                <FaPlus /> Adicionar Gestora
              </button>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-3 col-12">
              <label className="form-label fw-bold">Nome</label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Digite o nome da gestora"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value)}
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">E-mail</label>
              <input
                type="email"
                autoComplete="off"
                placeholder="Digite o e-mail"
                value={filtroEmail}
                className="form-control"
                onChange={(e) => setFiltroEmail(e.target.value)}
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">CNPJ</label>
              <InputMask
                mask="__.___.___/____-__"
                replacement={{ _: /\d/ }}
                name="cnpj"
                value={filtroCnpj}
                onChange={(e) => setFiltroCnpj(e.target.value)}
                className="form-control"
                autoComplete="off"
                placeholder="Digite o CNPJ"
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="table-custom-primary">
                  <tr>
                    <th>Nome</th>
                    <th>Telefone</th>
                    <th>E-mail</th>
                    <th>CNPJ</th>
                    <th>Cidade</th>
                    <th>Status</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {gestoras.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        Nenhuma gestora encontrada.
                      </td>
                    </tr>
                  ) : (
                    gestoras.map((gestora) => (
                      <tr key={gestora.id}>
                        <td className="text-nowrap">{gestora.nome}</td>
                        <td className="text-nowrap">{gestora.telefone}</td>
                        <td className="text-nowrap">{gestora.email}</td>
                        <td className="text-nowrap">{formatCnpj(gestora.cnpj)}</td>
                        <td className="text-nowrap">{gestora.cidade}</td>
                        <td className="text-nowrap">
                          <span className={`badge ${gestora.ativo ? 'bg-success' : 'bg-secondary'}`}>
                            {gestora.ativo ? 'Ativo' : 'Inativo'}
                          </span>
                        </td>
                        <td className="text-nowrap text-center">
                          <button
                            className="btn btn-custom-secondary btn-sm"
                            onClick={() => handleEditGestora(gestora)}
                            title="Editar"
                          >
                            <FaEdit />
                          </button>
                          <button
                            className="btn btn-custom-secondary btn-sm ms-3"
                            onClick={() => handleUnidadesGestora(gestora)}
                            title="Unidades"
                          >
                            <FaStore />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <span>
              Total de registros: <strong>{totalRegistros}</strong>
            </span>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>

        {isModalOpen && (
          <GestoraModal
            gestora={selectedGestora}
            onClose={() => setIsModalOpen(false)}
            onGestoraAtualizada={() => fetchGestoras(currentPage)}
          />
        )}
      </div>
      <div style={{ height: '50px' }}></div>
    </div>
  );
};

export default Gestoras; 